
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import draggable from "vuedraggable";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";

@Component({
    components: {
        draggable,
        TooltipDialog
    }
})
export default class DataEnrichissement extends Vue {

    headers = [];
    items = [];
    isLoadingData = false;
    ripple = false;
    drag = false;
    @Prop() readonly selectedData;
    @Prop() readonly dataTypes;

    changeOrder(event) {
        const tmp = this.selectedData.map((x) => x);
        const item = tmp.splice(event.moved.oldIndex, 1)[0];
        tmp.splice(event.moved.newIndex, 0, item);
        this.$emit('uploadDataToAdd', tmp);

    }
}
